'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Dictionary = require('./classes/Dictionary');

var _Dictionary2 = _interopRequireDefault(_Dictionary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _Dictionary2.default({
  CRYPTO_ETH: 'Ethereum (ETH)',
  CRYPTO_BTC: 'Bitcoin (BTC)',
  CRYPTO_XLM: 'Stellar (XLM)',
  CRYPTO_XRP: 'Ripple (XRP)',
  CRYPTO_USDC: 'USD Coin (USDC)',
  CRYPTO_TUSD: 'TrueUSD (TUSD)',
  CRYPTO_PAX: 'Paxos Standard (PAX)'
});